export default "__VITE_ASSET__CmyDYceT__"